import { render, staticRenderFns } from "./ReportsHome.vue?vue&type=template&id=34c0ba38&scoped=true&"
import script from "./ReportsHome.vue?vue&type=script&lang=js&"
export * from "./ReportsHome.vue?vue&type=script&lang=js&"
import style0 from "./ReportsHome.vue?vue&type=style&index=0&id=34c0ba38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c0ba38",
  null
  
)

export default component.exports